import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | error

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const res = await fetch(`${API}/payments/status/${sessionId}`);
        const data = await res.json();
        if (data.payment_status === "paid") { setState("paid"); return; }
      } catch (e) {
        console.debug("Payment status poll failed, retrying:", e);
      }
      if (++tries >= 8) { setState("error"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#F7F5F0] grid place-items-center px-6">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-lg text-center">
        {state === "checking" && (
          <>
            <Loader2 className="w-10 h-10 text-[#B85C38] animate-spin mx-auto" />
            <p className="mt-6 font-mono-a text-xs uppercase tracking-[0.2em] text-[#595550]">Confirming your reservation…</p>
          </>
        )}
        {state === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-[#5C6B50] grid place-items-center mx-auto">
              <Check className="w-8 h-8 text-[#F7F5F0]" />
            </div>
            <h1 data-testid="payment-success-heading" className="font-serif text-5xl lg:text-6xl tracking-tighter mt-8 leading-[1]">
              Your place is <span className="italic text-[#B85C38]">held.</span>
            </h1>
            <p className="mt-5 text-[#595550] text-lg leading-relaxed">
              Thank you — your $750 downpayment is confirmed. We'll be in touch shortly with your welcome details and everything you need before arrival.
            </p>
          </>
        )}
        {state === "error" && (
          <>
            <h1 className="font-serif text-4xl tracking-tighter">We couldn't confirm this payment.</h1>
            <p className="mt-4 text-[#595550] text-lg">If you were charged, don't worry — reach us at hello@agelesswomanretreat.com and we'll sort it out.</p>
          </>
        )}
        <Link to="/" data-testid="back-home" className="reserve-cta inline-block mt-10 bg-[#2C2A28] text-[#F7F5F0] px-8 py-4 rounded-full font-mono-a text-xs uppercase tracking-[0.2em] hover:bg-[#B85C38]">
          Return home
        </Link>
      </motion.div>
    </div>
  );
}
